import { Link, type LinkProps } from "react-router-dom";
import { useLocale } from "@/lib/i18n/useLocale";
import { localisePath } from "@/lib/i18n/registry";

/**
 * Внутренняя ссылка, которая НИКОГДА не уводит на другой язык (BTQ-47).
 *
 * Зачем. Ссылки внутри текста страниц зашиты английскими путями. На
 * португальской странице такая ссылка выбрасывала посетителя на английский
 * сайт — ровно то, за что версия v1 отправилась в откат, только наоборот.
 * Владелец поймал это первым же переходом в «Regiões».
 *
 * Что делает. Спрашивает у реестра португальский адрес того же маршрута.
 * Если своей страницы нет, но объявлена замена (`ptFallback`) — ведёт туда:
 * гео и площадки ведут в каталог quintas, потому что спецификация
 * pt-specs-v2/01 отдаёт гео-разрезы именно ему. Если вести некуда — рисует
 * текст без ссылки: подпись остаётся, посетитель остаётся.
 *
 * 🔴 Байт-идентичность. На английской локали `localisePath` возвращает путь
 * как есть, компонент рендерит тот же <Link> с тем же набором пропсов, и
 * английская разметка не меняется ни одним байтом.
 */
export default function LocalLink({ to, children, ...rest }: LinkProps) {
  const locale = useLocale();
  const href = typeof to === "string" ? localisePath(to, locale) : null;

  if (typeof to !== "string") return <Link to={to} {...rest}>{children}</Link>;
  if (href === null) return <>{children}</>;
  return <Link to={href} {...rest}>{children}</Link>;
}
